import { defineMessages } from 'react-intl-next';

export const messages: {
	campaignLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	endedOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	endsOn: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	campaignLabel: {
		id: 'search-graph-campaign.campaign-label',
		defaultMessage: 'Campaign',
		description: 'Campaign noun type label for Salesforce Campaign search results',
	},
	endedOn: {
		id: 'search-graph-campaign.ended-on',
		defaultMessage: 'Ended on {date}',
		description: 'Date when the Salesforce campaign ended',
	},
	endsOn: {
		id: 'search-graph-campaign.ends-on',
		defaultMessage: 'Ends on {date}',
		description: 'Future date when the Salesforce campaign is expected to end',
	},
});
